// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cfcBaseUrl: 'https://api.thecarplace.co.za/Capitec/Showroom',
  tcpBaseUrl: 'https://api.thecarplace.co.za/TheCarPlace/Showroom',
  // cfcBaseUrl: 'https://staging-api.thecarplace.co.za/Capitec/Showroom',
  // tcpBaseUrl: 'https://staging-api.thecarplace.co.za/TheCarPlace/Showroom',
  emailVehicleEnquiriesBaseUrl: 'https://carman-email-staging-api.thecarplace.co.za/api/Email/Send',
  emailOtherEnquiriesUrl: 'https://newsendemail.vmgsoftware.co.za/api/sendemail'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
